import React from "react";
import { Doughnut } from 'react-chartjs-2';
import ReactApexChart from "react-apexcharts";


type attributes = {
    size: number,
    male: number,
    female: number
}
export const EmployeeGenderStat = (props: attributes) => {

    const series = [props.male, props.female];
    const data = {
        labels: [`Male: ${props.male}`, `Female: ${props.female}`],
        responsive: [{
            options: {
                legend: {
                    position: 'left',
                    horizontalAlign:'center'
                }
            }
        }]
    };

    return <ReactApexChart options={data} series={series} type="pie" width={props.size} height={props.size} />

    //return <Doughnut data={data} width={props.size} options={{ plugins:{legend:{position:"bottom"}},  maintainAspectRatio: true }} />;

    // const data = {
    //     labels: ['Male:'+props.male, 'Female:'+props.female],
    //     datasets: [
    //         {
    //             data: [props.male, props.female],
    //             backgroundColor: [
    //                 'rgba(54, 162, 235, 0.2)',
    //                 'rgba(255, 99, 132, 0.2)',
    //             ],
    //             borderColor: [
    //                 'rgba(54, 162, 235, 1)',
    //                 'rgba(255, 99, 132, 1)',
    //             ],
    //             borderWidth: 1,
    //         },
    //     ],
    // };

    // return <Doughnut data={data} width={props.size} options={{ plugins:{legend:{position:"bottom"}},  maintainAspectRatio: true }} />;

}
